import { gql } from "lib/apolloClient";

export const getAiUsageMetricsQuery = gql`
  query getAiUsageMetrics($id: ID!) {
    node(id: $id, type: AI_USAGE_METRICS) {
      id
      ... on AiUsageMetrics {
        id
        type
        inputText
        responseText
        promptTokens
        completionTokens
        cachedPromptTokens
        model
        temperature
        metadata
        entityType
        entityId
        prompt {
          id
          metadata
        }
      }
    }
  }
`;
